import React, { useEffect } from 'react';
import { Button } from "@progress/kendo-react-buttons";
import './index.css';

const AlertBadge = ({ onClose, top }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);
        return () => clearTimeout(timer);
      }, [onClose]);
    return (
        <div className='d-flex justify-content-center'>
            <div className='alertBadge' style={{top: top ? top : '45px'}}>
                <div><b>Data is refreshing to show the most recent information.</b></div>
                <Button fillMode="flat" icon="close" size='small' onClick={onClose} />
            </div>
        </div>
    );
};

export default AlertBadge;